import React, { useEffect, useState } from 'react';
import UploadDocument from './UploadDocument';

const InputDocuments = ({ type = 'both', setEdictoFile, edictoFile, setNotaSimpleFile, notaSimpleFile }) => {

    const [showEdicto, setShowEdicto] = useState(false);
    const [showNotaSimple, setShowNotaSimple] = useState(false);
    const [isEdictoOpen, setIsEdictoOpen] = useState(false);
    const [isNotaSimpleOpen, setIsNotaSimpleOpen] = useState(false);
    const [showDescription, setShowDescription] = useState(true);

    useEffect(() => {
        if (isEdictoOpen) {
            setIsNotaSimpleOpen(false);
        }
    }, [isEdictoOpen]);

    useEffect(() => {
        if (isNotaSimpleOpen) {
            setIsEdictoOpen(false);
        }
    }, [isNotaSimpleOpen]);

    useEffect(() => {
        if (type === 'both') {
            setShowEdicto(true);
            setShowNotaSimple(true);
            setShowDescription(true);
        } else if (type === 'edicto') {
            setShowEdicto(true);
            setShowNotaSimple(false);
            setShowDescription(false);
        } else if (type === 'nota-simple') {
            setShowEdicto(false);
            setShowNotaSimple(true);
            setShowDescription(false);
        }
    }, [type]);

    return (
        <div className="h-full w-full flex flex-col gap-8 items-center justify-center">
            {showEdicto && <UploadDocument type={'edicto'} showDescription={showDescription} setFile={setEdictoFile} file={edictoFile} isOpen={isEdictoOpen} setIsOpen={setIsEdictoOpen} />}
            {showNotaSimple && <UploadDocument type={'nota-simple'} showDescription={showDescription} setFile={setNotaSimpleFile} file={notaSimpleFile} isOpen={isNotaSimpleOpen} setIsOpen={setIsNotaSimpleOpen} />}
        </div>
    );
};

export default InputDocuments;